<template>
    <!-- Header Section -->
    <div class="row wrapper border-bottom white-bg page-heading">
        <!-- Title on the left -->
        <div class="col-lg-8 align-self-center">
            <h2 class="mb-0">Form Approval</h2>
        </div>
        <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
      <i class="fa fa-times close" @click="onclosed()"></i>
      <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="row mb-2">
            <div v-if="fromdata.language != 'English'" class="col-lg-6 px-1">
                <div class="ibox mb-2">
                    <div class="ibox-title style_2 d-flex justify-content-between align-items-center maxheight">
                        <div>
                              
                               <h4>{{ fromdata.templateName }}</h4> 
                               <p>Language - English</p>
                            <!-- <h5 class="mb-0">Randomization Form - <small class="ml-2"> v1.0</small></h5> -->
                        </div>
                        <div class=" d-flex justify-content-end py-1">
                   
                    </div>
                    </div>
                    <div class="ibox-content contentheight">
                        <!-- Form Field Section -->
                        <div class="max-h-400" v-for="eachfields in crfsourcedata" :key="eachfields.fieldName">
                            <div class="card d-flex justify-content-between gap-1 form-field-card px-3 py-0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0"> <small>Field Name: <span> {{ eachfields.fieldName
                                                }}</span></small></h6>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p class="text-muted mb-0">Field Label: <span> {{ eachfields.label }}</span></p>
                                    <div class="d-flex justify-content-between-end gap-1">

                                    </div>
                                </div>
                                <div class="d-flex gap-5">
                                    <p class="text-muted mb-0">Field type: <span> {{ eachfields.type }}</span></p>
                                    <p class="text-muted mb-0" v-if="setoptions(eachfields.options) != ''">Options:<span class="ml-1"> {{  setoptions(eachfields.options)}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
<div :class="fromdata.language != 'English'?'col-lg-6 px-1':'col-lg-12 px-1' ">
                <div class="ibox mb-2">
                    <div class="ibox-title style_2 d-flex justify-content-between align-items-center maxheight">
                        <div>
                              
                               <h4>{{ fromdata.templateName }} </h4>
                                <p>Language - {{ fromdata.language }}</p>
                            <!-- <h5 class="mb-0">Randomization Form - <small class="ml-2"> v1.0</small></h5> -->
                        </div>
                        <div class=" d-flex justify-content-end py-1">
                        <button v-if="fromdata.status != 'Approved' && fromdata.status != 'Rejected'" class="btn btn-sm btn-outline-danger py-0 me-1" @click="approveorrejectfun('Reject')">
                            <small>Reject</small>
                        </button>
                        <button v-if="fromdata.status != 'Approved' && fromdata.status != 'Rejected'" class="btn btn-sm btn-primary py-0 mr-4" @click="approveorrejectfun('Approve')">
                            <small>Approve</small>
                        </button>
                        <div v-if="fromdata.status == 'Approved'">
                        <span>Approved By: {{ fromdata.lastModifiedUserEmail }}</span>
                        <p >Approved Date: {{ getcorrectdate(fromdata.lastModifiedAt) }}</p>
                        </div>
                    </div>
                    </div>
                    <div class="ibox-content contentheight">
                        <!-- Form Field Section  -->
                        <div class="max-h-400" v-for="eachfields in crfdata" :key="eachfields.fieldName">
                            <div class="card d-flex justify-content-between gap-1 form-field-card px-3 py-0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0"> <small>Field Name: <span> {{ eachfields.fieldName
                                                }}</span></small></h6>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p class="text-muted mb-0">Field Label: <span> {{ eachfields.label }}</span></p>
                                    <div class="d-flex justify-content-between-end gap-1">
                                        <button v-if="!disableeditcheckfor.includes(eachfields.type)" class="btn btn-sm btn-outline-primary ms-2 py-0" @click="openeditcheckpopup(eachfields.fieldName)"><i
                                                class="fa fa-eye me-1"></i> Edit Check</button>
                                               <button v-if="fromdata.status != 'Approved' && fromdata.status != 'Rejected'" class="btn btn-sm btn-primary ms-2 py-0" @click="openFieldPopup(eachfields)"><i
                                                class="fa fa-edit me-1"></i> Edit</button> 
                                    </div>
                                </div>
                                <div class="d-flex gap-5">
                                    <p class="text-muted mb-0">Field type: <span> {{ eachfields.type }}</span></p>
                                    <p class="text-muted mb-0" v-if="setoptions(eachfields.options) != ''">Options:<span class="ml-1"> {{  setoptions(eachfields.options)}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <customModal
    v-if="editcheckmodal == true"
    :containermd="true"
    :footerShow="true"
    @closeModal="closeeditcheckModal()"
  >
    <template #title>
     Edit Check
    </template>
    <template #body>
      <div class="row mb-2">
        <table class="table table-bordered">
                <thead>
                  <tr>
                    <th> Condition</th>
                    <th> Value</th>
                    <th> Message</th>
                    <th> Message Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(editheck) in editcheckdetails" :key="editheck">
                    <td class="align-items-center fixed-width-table-cell">
                     {{ editheck.condition }}
                    </td>
                    <td class="align-items-center fixed-width-table-cell">
                      {{ editheck.value.join(', ') }}
                    </td>
                    <td class="text-center adjustwidth">
                     {{ editheck.message }}
                    </td>
                    <td class="text-center" >
                     {{ editheck.messageType }}
                    </td>
                  </tr>
                </tbody>
              </table>
      </div>

      <div class="modal-footer d-flex justify-content-end">

        <button
          
          type="button"
          class="save_btn py-1 px-3 position-relative"
          @click="closeeditcheckModal()"
        >
          OK
        </button>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
       
      >

      </div>
    </template>
  </customModal>
  <!-- approve or reject popup -->
   <customModal
    v-if="approveorrejectpopup == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="approveorrejectpopup = false"
  >
    <template #title>
     {{ approveorreject }}
    </template>
    <template #body>
      <div class="row mb-2">
        <label>{{ $t("navigations.comments") }}</label>
        <textarea v-model="approvecomments"></textarea>
      </div>

      <div class="modal-footer d-flex justify-content-end">
        <button
          v-if="approveorreject == 'Reject Form'"
          type="button"
          class="btn btn-danger py-1 px-3 position-relative"
          @click="assigntemplate('Rejected')"
        >
          Reject
        </button>
        <button
          v-if="approveorreject == 'Approve Form'"
          type="button"
          class="save_btn py-1 px-3 position-relative"
          @click="assigntemplate('Approved')"
        >
          Approve
        </button>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between"
       
      >

      </div>
    </template>
  </customModal>
  <!-- approve or reject popup ends -->
   <!-- edit field model starts -->
    <!-- modal 2 starts -->
     <edittemlatefieldpopup
  v-if="componentModal"
  :model-value="componentModal"
  :templateId="tempId"
  :value="currentField"
  :page-no="currentFieldPageNo"
  :index-on-page="currentFieldIndex"
  @closeeditmodal="closemodaltwo"
  @saved="handleFieldSaved"
/>




  <!-- modal ends -->
    <!-- edit field model ends -->
</template>
<script src="./crfViewsingle.js"></script>
<style scoped>
.form-field-card {
    border-left: 3px solid #0d6efd;
    margin-bottom: 0.4rem;
}

.clickable-icon {
    cursor: pointer;
}

.clickable-icon :hover {
    color: #494949;
}

.ibox-footer {
    background-color: #ffffff;
    border-color: #e7eaec;
    border-image: none;
    border-style: none solid solid;
    border-width: 1px;
    color: inherit;
    padding: 8px 15px 8px 15px;
    min-height: 32px;
    position: relative;
    clear: both;
    width: unset;
    -webkit-border-radius: 0 0 3px 3px;
    -moz-border-radius: 0 0 3px 3px;
    border-radius: 0 0 3px 3px;
}
.contentheight {
    height: 73vh;
    overflow: auto;
}
.adjustwidth {
    width: 40%;
    text-wrap: auto;
}
.maxheight {
    max-height: 90px;
}
</style>
